module.exports = __webpack_public_path__ + "static/media/blog-hai-ask@2x.606cd7fc.jpg";